module.exports = __webpack_public_path__ + "static/media/orders_doller.c39fcca6.svg";